module.exports = __webpack_public_path__ + "components/flag/static/square/je-aad7609088910f35b0ee9ea6ec23d998.svg";